var beneficiaryTypeCodes = {
    Individual: "IND",
    BeneficiaryInfoOnFile: "FIL",
    Estate: "EST",
    SurvivingChildren: "SUR",
    Trust: "TRU",
    PerStirpes: "PER",
    PerCapita: "CAP",
    Other: "OTH",
    CharityOrganization: "CHO",
    Corporation: "COR"
};

export default beneficiaryTypeCodes;
